import axios from "axios";
import axiosInstance, { axiosNAKBHOInstance } from "../../interceptor/intercetptor-inctence";

const getPharmacyPOSState = () => {
	try {
		const saved = localStorage.getItem("currentPharmacyPOS");
		const pharmacy = saved ? JSON.parse(saved) : null;
		return pharmacy?.state || "";
	} catch {
		return "";
	}
};

const withPharmacyState = (data = {}) => ({
	...data,
	state: data.state ?? getPharmacyPOSState(),
});


export const uploadBulkItem = (file) => {
	return axiosInstance.post(`pharma/bulkUploadItems`, file);
	// return axiosInstance.post(`superadmin/bulkUploadItems`, file);
}

export const exportPharmaItemsAPI = (data = {}) => {
	return axiosInstance.post(`/pharma/exportPharmaItems`, data);
};

export const importPharmaItemsAPI = (data) => {
	return axiosInstance.post(`/pharma/importPharmaItems`, data);
};

export const downloadSampleFile = () => {
	const headers = {
		"ngrok-skip-browser-warning": "true"
	}
	return axiosInstance.post(`superadmin/uploadItemTemplate`, {}, { headers });
}

export const exportMedicineToExcel = () => {
	const headers = {
		"ngrok-skip-browser-warning": "69420"
	}
	return axiosInstance.post(`superadmin/exportItemToExcel`, {}, { headers });
}

export const getSaltOnSearch = (data) => {
	return axiosInstance.post(`healthcare_providers/search/medicine`, withPharmacyState(data))
	// return axios.post(`https://stage-api.pharmacy.clinicdots.com/healthcare_providers/search/medicine`, data)
	// return axiosNAKBHOInstance.post(`healthcare_providers/search/medicine`, data)
}

export const getPharmacyItems = (data) => {
	return axiosInstance.post(`pharma/masterItem`, data)
	// return axiosNAKBHOInstance.post(`healthcare_providers/search/medicine`, data)
}

export const getItemsList = (data) => {
	return axiosInstance.post(`pharma/get-all`, data);
	// return axiosInstance.post(`superadmin/getItemList`, data);
}

export const fetchAllPharmacyItems = async ({ clinicId, search = "", isOTC = false }) => {
	const countResponse = await axiosInstance.post(`pharma/get-all`, {
		clinicId,
		page: 1,
		limit: 1,
		search,
		isOTC,
	});
	const total = countResponse.data?.data?.total || 0;
	if (!total) return [];

	const response = await axiosInstance.post(`pharma/get-all`, {
		clinicId,
		page: 1,
		limit: total,
		search,
		isOTC,
	});
	if (response.data?.status === "success") {
		return response.data.data.items || [];
	}
	return [];
};

export const getItemDetails = (data) => {
	return axiosInstance.post(`pharma`, data);
	// return axiosInstance.post(`superadmin/getItemDetails`, data);
}

export const addNewItem = (data) => {
	return axiosInstance.post(`pharma/add-item`, data);
	// return axiosInstance.post(`superadmin/updateItem`, data);
}

export const updateItemInfo = (data) => {
	return axiosInstance.patch(`pharma/update-item`, data);
	// return axiosInstance.post(`superadmin/updateItem`, data);
}

export const deleteItem = (data) => {
	return axiosInstance.post(`superadmin/deleteItem`, data);
}

export const addSaltNameApi = (data) => {
	return axiosInstance.post(`healthcare_providers/search/createPlatformMedication`, data);
	// return axios.post(`https://dev-api.clinicdots.com/healthcare_providers/medication/add-new`, data);
}

// Search OTC master
export const searchOTCMasterApi = async (payload) => {
	try {
		const response = await axiosInstance.post("/healthcare_providers/search/medicine", withPharmacyState(payload));
		// const response = await axios.post(`https://stage-api.pharmacy.clinicdots.com/healthcare_providers/search/medicine`, payload)
		return response;
	} catch (error) {
		console.error("Error searching OTC master:", error);
		throw error;
	}
};

// Create platform OTC item
export const createPlatformOTCItem = async (payload) => {
	try {
		const response = await axiosInstance.post("/healthcare_providers/search/createPlatformMedication", payload);
		return response;
	} catch (error) {
		console.error("Error creating OTC item:", error);
		throw error;
	}
};